import React, {useContext, useEffect, useCallback} from "react";
import styled from "styled-components";
import tw from "twin.macro";
import KeyButton, {KeyDelete, KeyEnter} from "./Key";
import {AppContext} from "../App";

const KeyboardContainer = styled.div`

  ${tw`
  flex
  flex-col
  items-center
  justify-center
  h-40
  
  sm:h-48
  md:h-52
  lg:h-52
    `}
`

const KeyboardWidth = styled.div`

  ${tw`
    flex
    flex-col
    items-center
    justify-center

    `}
`

const KeyRow = styled.div`
  ${tw`
    flex
    flex-row
    `}
`
const KeyRow1 = styled.div`
  ${tw`
    flex
    flex-row
    `}
`
const KeyRow2 = styled.div`
  ${tw`
    flex
    flex-row
    `}
`



export default function Keyboard() {
    const key1 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"]
    const key2 = ["a", "s", "d", "f", "g", "h", "j", "k", "l"]
    const key3 = ["z", "x", "c", "v", "b", "n", "m"]
    const {board, setBoard, currAttempt, setCurrAttempt, onEnter, onDelete, onSelectLetter, disabledLetters, almostLetters, errorLetters, correctLetters, setCorrectLetters } = useContext(AppContext)

    const handleKeyboard = useCallback((event) => {
        if (event.key === "Enter") {
            onEnter()
        } else if (event.key === 'Backspace') {
            onDelete()
        } else {
            key1.forEach((key) => {
                if (event.key.toLowerCase() === key.toLowerCase()) {
                    onSelectLetter(key)
                }
            })
            key2.forEach((key) => {
                if (event.key.toLowerCase() === key.toLowerCase()) {
                    onSelectLetter(key)
                }
            })
            key3.forEach((key) => {
                if (event.key.toLowerCase() === key.toLowerCase()) {
                    onSelectLetter(key)
                }
            })
        }
    })

    useEffect(() => {
        document.addEventListener("keydown", handleKeyboard)

        return () => {
            document.removeEventListener("keydown", handleKeyboard)
        };
    }, [handleKeyboard])

    return (
        <>
            <KeyboardContainer>
                <KeyboardWidth>
                    <KeyRow>
                        {key1.map((Key => {
                            return <KeyButton
                                keyVal={Key}
                                key={Key}
                                id={Key}
                                disabled={disabledLetters.includes(Key)}
                                almost={almostLetters.includes(Key)}
                                error={errorLetters.includes(Key)}
                                correct={correctLetters.includes(Key)}
                            />
                        }))}
                    </KeyRow>

                    <KeyRow1>
                        {key2.map((Key => {
                            return <KeyButton
                                keyVal={Key}
                                key={Key}
                                id={Key}
                                disabled={disabledLetters.includes(Key)}
                                almost={almostLetters.includes(Key)}
                                error={errorLetters.includes(Key)}
                                correct={correctLetters.includes(Key)}
                            />
                        }))}
                    </KeyRow1>

                    <KeyRow2>
                        <KeyEnter keyVal={"Enter"} big />

                        {key3.map((Key => {
                            return <KeyButton
                                keyVal={Key}
                                key={Key}
                                id={Key}
                                disabled={disabledLetters.includes(Key)}
                                almost={almostLetters.includes(Key)}
                                error={errorLetters.includes(Key)}
                                correct={correctLetters.includes(Key)}
                            />
                        }))}
                        <KeyDelete keyVal={"Backspace"} big />
                    </KeyRow2>
                </KeyboardWidth>

            </KeyboardContainer>
        </>
    )
}
